/* global axios */
import ApiClient from '../ApiClient';

class AllegroClient extends ApiClient {
  constructor() {
    super('allegro', { accountScoped: true });
  }

  generateAuthorization(payload) {
    return axios.post(`${this.url}/authorization`, payload);
  }
}

export default new AllegroClient();
